module.exports = __webpack_public_path__ + "static/media/logos-print-light.beaa84c8.jpg";